import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useTheme } from "@hooks/useTheme";
import { isAuthenticated as checkUserAuthenticated } from "@utils/auth";

const AuthSplitLayout = () => {
  const { colors } = useTheme();
  const location = useLocation();

  if (checkUserAuthenticated() && location.pathname === "/login") {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className={`flex h-full ${colors.bgSecondary}`} data-testid="auth-layout">
      {/* Login Form Section */}
      <div className="w-full flex items-center justify-center px-4 sm:px-6 lg:px-8 py-12">
        <div className="w-full max-w-md">
          <div className={`${colors.bgPrimary} rounded-lg shadow-xl overflow-hidden border ${colors.borderPrimary}`}>
            {/* Header */}
            <div
              className={`px-6 py-4 text-center ${colors.bgActivePrimary} rounded-t-lg`}
            >
              <h1 className={`text-3xl font-bold ${colors.textPrimary}`}>Clarity Supply Chain</h1>
            </div>

            {/* Body */}
            <div className="px-6 py-8">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthSplitLayout;
